import React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setTab } from "./redux/projectSlice";
import "./Tabs.css";
import ProjectAccordionList from "./ShowProjects";
import SubjectProjects from "./subjectProjects";
import MyProjects from "../WeeklyLessons/Projects/MyProjects";
function Tab1() {
  return (
    <div className="tab-content">
      <MyProjects />
    </div>
  );
}

// function Tab2() {
//   return (
//     <div className="tab-content">
//       <SubjectProjects />
//     </div>
//   );
// }

// function Tab3() {
//   return (
//     <div className="tab-content">
//       <ProjectAccordionList />
//     </div>
//   );
// }

export default function TabContainer() {
  const dispatch = useDispatch();
  const { currentTab: tab } = useSelector((state) => state.project);

  const handleChange = (event, newValue) => {
    dispatch(setTab(newValue));
  };

  return (
    <Box className="tabs-container">
      <Tabs
        value={tab}
        onChange={handleChange}
        className="custom-tabs"
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab label="My Projects" className="custom-tab" />
        {/* <Tab label="Subject-wise Projects" className="custom-tab" />
        <Tab label="From Academic Calendar" className="custom-tab" /> */}
      </Tabs>

      <Box className="tab-box">
        {tab === 0 && <Tab1 />}
        {/* {tab === 1 && <Tab2 />}
        {tab === 2 && <Tab3 />} */}
      </Box>
    </Box>
  );
}
